import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/takeUntil';
import {StandardCleanupTarget, StandardSourceRemovalRequest} from '../../../models/standard-distribution.model';
import {STANDARD_ASSIGNMENT_ERROR, standardAssignmentErrorCode, standardAssignmentErrorKey} from '../../../services/standard-assignment-error';
import {StdManagementService} from './std-management.service';
import {DepartmentsModel} from './models/departments.model';
import {PositionsModel} from './models/positions.model';
import {UsersModel} from './models/users.model';
import {RemoveUserComponent} from './modals/remove-user/remove-user.component';
import {AssignStandardsComponent} from './modals/assign-standards/assign-standards.component';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NotifierService} from 'angular-notifier';

const HTTP_NETWORK_ERROR = 0;
const HTTP_SERVER_ERROR = 500;
const HTTP_FORBIDDEN = 403;
const NO_REMOVAL_ERROR = '';
const REMOVE_CONFIRMED = 'Yes';
const REMOVAL_ERROR = {
  failed: 'STANDARD_ASSIGNMENT_SAVE_FAILED',
  load: 'STANDARD_ASSIGNMENT_RELOAD_FAILED',
  access: 'STANDARD_ASSIGNMENT_CLEANUP_ACCESS_LOST'
};
interface ManagedStandard { id: string; number?: string; }

@Component({
  selector: 'app-standards-management',
  templateUrl: './standards-management.component.html',
  styleUrls: ['./standards-management.component.css']
})
export class StandardsManagementComponent implements OnInit, OnDestroy {

  removalPending = false;
  removalSuccess = false;
  removalRequiresReload = false;
  removalErrorKey = NO_REMOVAL_ERROR;
  cleanupTargets: StandardCleanupTarget[] = [];
  private destroyed = false;
  private destroyed$ = new Subject<void>();

  errorLoading = false;

  usersLoaded = false;
  departmentsLoaded = false;
  positionsLoaded = false;

  leftColumnStandardsLoaded = false;
  leftColumnPersonalStandardsLoaded = false;

  departments: DepartmentsModel;
  departmentsRightColumn: DepartmentsModel;
  positions: PositionsModel;
  positionsRightColumn: PositionsModel;
  users: UsersModel;
  standardsLeftColumn = [];
  personalStandardsLeftColumn = [];
  selectedStandardsLeftColumn = [];
  selectedStandardsRightColumn = [];
  selectedPersonalStandardsLeftColumn = [];
  inactiveByPositionsStandards = [];
  selectedInactiveByPositionStandards = [];

  standardsRightColumn = [];


  selectedDepartment = {
    id: '',
    name: 'Select Department'
  };
  selectedPosition = {
    id: '',
    name: 'Select Position'
  };
  selectedUser = {
    id: '',
    fullName: 'Select User'
  };

  selectedDepartmentRightColumn = {
    id: '',
    name: 'Select Department'
  };

  selectedPositionRightColumn = {
    id: '',
    name: 'Select Position'
  };

  numberInput = '';
  nameInput = '';

  searchTextDepartmentsLeft;
  searchTextPositionsLeft;
  searchTextUsers;
  searchTextDepartmentsRight;
  searchTextPositionsRight;

  private readonly notifier: NotifierService;

  constructor(private stdManagementService: StdManagementService,
              private modalService: NgbModal,
              notifierService: NotifierService) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.searchUser();
    this.searchGroup();
    this.searchGroupRight();
    this.searchPositions();
    this.searchPositionsRightColumn();
    this.searchStandardsWithName();

  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  get removalBlocked(): boolean { return this.removalPending || this.removalRequiresReload; }

  // API Requests

  searchUser() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      groupId: '',
      positionId: ''
    };

    if (this.selectedDepartment.id.length > 0) {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id.length > 0) {
      params.positionId = this.selectedPosition.id;
    }

    this.stdManagementService.searchManagementUser(params.searchField, params.searchOperation, params.searchValue, params.groupId, params.positionId).subscribe(
      (response: any) => {
        this.users = response.body;
        this.usersLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchGroup() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedPosition.id.length > 0) {
      params.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id.length > 0) {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchManagementGroup(params.searchField, params.searchOperation, params.searchValue, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.departments = response.body;
        this.departmentsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchPositions() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      groupId: '',
      userId: ''
    };

    if (this.selectedDepartment.id.length > 0) {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedUser.id.length > 0) {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchManagementPositions(params.searchField, params.searchOperation, params.searchValue, params.groupId, params.userId).subscribe(
      (response: any) => {
        this.positions = response.body;
        this.positionsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchStandardsWithUser() {
    const params = {
      groupId: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedDepartment.id !== '') {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id !== '') {
      params.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id !== '') {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchStandardsWithUser(params.groupId, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.standardsLeftColumn = response.body;
        this.leftColumnStandardsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchPersonalStandards() {
    const params = {
      groupId: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedDepartment.id !== '') {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id !== '') {
      params.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id !== '') {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchPersonalStandards(params.groupId, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.personalStandardsLeftColumn = response.body;
        this.leftColumnPersonalStandardsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchInactiveByPosition() {
    const params = {
      groupId: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedDepartment.id !== '') {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id !== '') {
      params.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id !== '') {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchStandardsWithoutUserOnPosition(params.groupId, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.inactiveByPositionsStandards = response.body;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchStandardsWithName() {
    this.selectedStandardsRightColumn = [];
    const params = {
      groupId: '',
      positionId: '',
      number: '',
      name: ''
    };

    if (this.selectedDepartmentRightColumn.id.length > 0) {
      params.groupId = this.selectedDepartmentRightColumn.id;
    }

    if (this.selectedPositionRightColumn.id.length > 0) {
      params.positionId = this.selectedPositionRightColumn.id;
    }

    if (this.nameInput.trim() !== '') {
      params.name = this.nameInput.trim();
    }

    if (this.numberInput.trim() !== '') {
      params.number = this.numberInput.trim();
    }

    this.stdManagementService.searchStandardsWithName(params.groupId, params.positionId, params.number, params.name).subscribe(
      (response: any) => {
        this.standardsRightColumn = response.body;
      },
      () => {
        this.errorLoading = true;
      });
  }

  // Remove the captured selection; recovery never repeats this command.
  removeStandards(request = this.captureRemovalRequest()): void {
    if (this.removalBlocked || this.destroyed || !request.standards.length) { return; }
    this.removalPending = true;
    this.removalSuccess = false;
    this.removalErrorKey = NO_REMOVAL_ERROR;
    this.stdManagementService.removeUsersFromStandards(request).takeUntil(this.destroyed$).subscribe(
      () => { this.removalPending = false; this.removalSuccess = true; this.reloadRemovalLists(); },
      error => this.handleRemovalError(error, request)
    );
  }

  private captureRemovalRequest(): StandardSourceRemovalRequest {
    const ids: string[] = this.selectedStandardsLeftColumn.concat(this.selectedPersonalStandardsLeftColumn);
    return {
      standards: ids.filter((id, index) => ids.indexOf(id) === index),
      groupId: this.selectedDepartment.id, positionId: this.selectedPosition.id, userId: this.selectedUser.id
    };
  }

  private handleRemovalError(error: HttpErrorResponse, request: StandardSourceRemovalRequest): void {
    this.removalPending = false;
    this.removalRequiresReload = true;
    this.removalErrorKey = standardAssignmentErrorKey(error)
      || (error.status === HTTP_FORBIDDEN ? REMOVAL_ERROR.access : REMOVAL_ERROR.failed);
    const sourceRemoval = request.groupId && !request.positionId && !request.userId;
    const uncertain = error.status === HTTP_NETWORK_ERROR || error.status >= HTTP_SERVER_ERROR;
    const cleanup = standardAssignmentErrorCode(error) === STANDARD_ASSIGNMENT_ERROR.cleanup;
    if (cleanup || (sourceRemoval && uncertain)) { this.captureCleanupTargets(request.standards); }
  }

  private captureCleanupTargets(standardIds: string[]): void {
    const standards: ManagedStandard[] = this.standardsLeftColumn.concat(this.personalStandardsLeftColumn);
    this.cleanupTargets = standardIds.map(id => {
      const standard = standards.find(item => item.id === id);
      return {id: id, label: standard && standard.number || id};
    });
  }

  reloadRemovalLists(): void {
    if (this.removalPending || this.destroyed) { return; }
    this.removalPending = true;
    this.removalRequiresReload = true;
    const selection = this.captureRemovalRequest();
    const requests = this.removalReloadRequests(selection);
    Observable.forkJoin(requests).takeUntil(this.destroyed$).subscribe(
      (responses: HttpResponse<ManagedStandard[]>[]) => this.acceptRemovalLists(responses),
      () => {
        this.removalPending = false;
        this.removalErrorKey = REMOVAL_ERROR.load;
      }
    );
  }

  private removalReloadRequests(selection: StandardSourceRemovalRequest) {
    const empty = Observable.of(new HttpResponse<ManagedStandard[]>({body: []}));
    return [
      this.stdManagementService.searchStandardsWithUser(selection.groupId, selection.positionId, selection.userId),
      selection.userId ? this.stdManagementService.searchPersonalStandards(selection.groupId, selection.positionId, selection.userId) : empty,
      selection.userId && selection.positionId ? this.stdManagementService.searchStandardsWithoutUserOnPosition(
        selection.groupId, selection.positionId, selection.userId) : empty,
      this.stdManagementService.searchStandardsWithName(this.selectedDepartmentRightColumn.id,
        this.selectedPositionRightColumn.id, this.numberInput.trim(), this.nameInput.trim())
    ];
  }

  private acceptRemovalLists(responses: HttpResponse<ManagedStandard[]>[]): void {
    const [standards, personal, inactive, available] = responses.map(response => response.body || []);
    this.standardsLeftColumn = standards;
    this.personalStandardsLeftColumn = personal;
    this.inactiveByPositionsStandards = inactive;
    this.standardsRightColumn = available;
    this.clearSelectedStandards();
    this.clearSelectedPersonalStandards();
    this.clearInactiveByPositionStandards();
    this.clearSelectedStandardsRightColumn();
    this.leftColumnStandardsLoaded = true;
    this.leftColumnPersonalStandardsLoaded = true;
    this.cleanupTargets = [];
    this.removalPending = false;
    this.removalRequiresReload = false;
    this.removalErrorKey = NO_REMOVAL_ERROR;
  }

  // Assign standards
  assignStandards() {
    const reqBody = {
      standards: this.selectedStandardsRightColumn,
      groupId: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedInactiveByPositionStandards.length > 1) {
      this.selectedInactiveByPositionStandards.forEach(standard => {
        reqBody.standards.push(standard);
      });
      reqBody.standards = reqBody.standards.filter((x, i, a) => a.indexOf(x) === i);
    }

    if (this.selectedStandardsRightColumn.length < 1 && this.selectedInactiveByPositionStandards.length > 0) {
      reqBody.standards = this.selectedInactiveByPositionStandards;
    }

    if (this.selectedDepartment.id !== '') {
      reqBody.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id !== '') {
      reqBody.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id !== '') {
      reqBody.userId = this.selectedUser.id;
    }

    reqBody.standards.forEach(std => {
    });

    this.stdManagementService.assignStandards(reqBody.standards, reqBody.groupId, reqBody.positionId, reqBody.userId).subscribe(
      () => {
        this.clearSelectedStandards();
        this.clearSelectedPersonalStandards();
        this.clearSelectedStandardsRightColumn();
        this.clearInactiveByPositionStandards();
        this.searchStandardsWithUser(); // Invoke this function to update left standards column with selected groupId, positionId and userId after unassign
        if (this.selectedUser.id.length > 1) {
          this.searchPersonalStandards();
        }
        if (this.selectedPosition.id.length > 0 && this.selectedUser.id.length > 0) {
          this.searchInactiveByPosition();
        }
        this.notifier.notify('success', 'Assign successful!');
      },
      () => {
        this.notifier.notify('error', 'Assign finished with error.');
      });
  }

  // Left Departments Dropdown

  selectDepartment(department) {
    this.selectedDepartment.id = department.id;
    this.selectedDepartment.name = department.name;

    if (this.selectedPosition.id.length > 0 && this.selectedUser.id.length > 0) {
      this.searchInactiveByPosition();
    }

    this.searchPositions();
    this.searchUser();
    this.clearSelectedStandards();
    this.clearSelectedPersonalStandards();
    this.searchStandardsWithUser();
  }

  // Left Positions Dropdown

  selectPosition(position) {
    this.selectedPosition.id = position.id;
    this.selectedPosition.name = position.name;
    this.clearSelectedStandards();
    this.clearSelectedPersonalStandards();

    if (this.selectedDepartment.id.length < 1) {
      this.searchGroup();
    }

    if (this.selectedUser.id.length > 0) {
      this.searchInactiveByPosition();
    }

    this.searchUser();
    this.searchStandardsWithUser();
  }

  // Left Users Dropdown

  selectUser(user) {
    this.selectedUser.id = user.id;
    this.selectedUser.fullName = user.fullName;
    this.clearSelectedStandards();
    this.clearSelectedPersonalStandards();
    this.searchPersonalStandards();
    if (this.selectedDepartment.id.length < 1) {
      this.searchGroup();
    }
    if (this.selectedPosition.id.length < 1) {
      this.searchPositions();
    }
    this.searchPositions();
    if (this.selectedDepartment.id.length > 0 || this.selectedPosition.id.length > 0) {
      this.searchStandardsWithUser();
    }

    if (this.selectedPosition.id.length > 0) {
      this.searchInactiveByPosition();
    }
  }

  clearAllLeftColumn() {
    this.selectedDepartment.id = '';
    this.selectedDepartment.name = 'Select Department';
    this.selectedPosition.id = '';
    this.selectedPosition.name = 'Select Position';
    this.selectedUser.id = '';
    this.selectedUser.fullName = 'Select User';
    this.selectedInactiveByPositionStandards = [];
    this.inactiveByPositionsStandards = [];
    this.clearSelectedStandards();
    this.clearSelectedPersonalStandards();
    this.searchGroup();
    this.searchPositions();
    this.searchUser();
  }

  // Left Standards List
  appendStandard(standardId) {

    if (this.selectedStandardsLeftColumn.includes(standardId)) {
      const index: number = this.selectedStandardsLeftColumn.indexOf(standardId);
      if (index !== -1) {
        this.selectedStandardsLeftColumn.splice(index, 1);
      }
    } else {
      this.selectedStandardsLeftColumn.push(standardId);
    }
  }

  appendPersonalStandard(standardId) {

    if (this.selectedPersonalStandardsLeftColumn.includes(standardId)) {
      const index: number = this.selectedPersonalStandardsLeftColumn.indexOf(standardId);
      if (index !== -1) {
        this.selectedPersonalStandardsLeftColumn.splice(index, 1);
      }
    } else {
      this.selectedPersonalStandardsLeftColumn.push(standardId);
    }
  }

  appendRightStandard(standardId) {

    if (this.selectedStandardsRightColumn.includes(standardId)) {
      const index: number = this.selectedStandardsRightColumn.indexOf(standardId);
      if (index !== -1) {
        this.selectedStandardsRightColumn.splice(index, 1);
      }
    } else {
      this.selectedStandardsRightColumn.push(standardId);
    }
  }

  appendInactiveStandard(standardId) {

    if (this.selectedInactiveByPositionStandards.includes(standardId)) {
      const index: number = this.selectedInactiveByPositionStandards.indexOf(standardId);
      if (index !== -1) {
        this.selectedInactiveByPositionStandards.splice(index, 1);
      }
    } else {
      this.selectedInactiveByPositionStandards.push(standardId);
    }
  }

  clearSelectedStandards() {
    this.selectedStandardsLeftColumn = [];
  }

  clearSelectedPersonalStandards() {
    this.selectedPersonalStandardsLeftColumn = [];
  }

  clearSelectedStandardsRightColumn() {
    this.selectedStandardsRightColumn = [];
  }

  clearInactiveByPositionStandards() {
    this.selectedInactiveByPositionStandards = [];
  }

  isSelectedStandard(standardId) {
    return this.selectedStandardsLeftColumn.includes(standardId);
  }

  isSelectedPersonalStandard(standardId) {
    return this.selectedPersonalStandardsLeftColumn.includes(standardId);
  }

  isSelectedAllStandards(standardId) {
    return this.selectedStandardsRightColumn.includes(standardId);
  }

  isSelectedInactiveStandard(standardId) {
    return this.selectedInactiveByPositionStandards.includes(standardId);
  }

  // Arrows

  // Unassign standards modal window alert
  openUnassignModal() {
    if (this.removalBlocked || this.destroyed || this.disabledUnassignButton()) { return; }
    const request = this.captureRemovalRequest();
    this.removalPending = true;
    const modalRef = this.modalService.open(RemoveUserComponent);
    modalRef.result.then((result) => {
      this.removalPending = false;
      if (result === REMOVE_CONFIRMED && !this.destroyed) {
        this.removeStandards(request);
      }
    }, () => { this.removalPending = false; });
  }

  // Assign standards modal window alert
  openAssignModal() {
    if (this.removalBlocked || this.destroyed) { return; }
    const modalRef = this.modalService.open(AssignStandardsComponent);
    modalRef.result.then((result) => {
      if (result === REMOVE_CONFIRMED && !this.removalBlocked && !this.destroyed) {
        this.assignStandards();
      }
    }, () => {});
  }

  // Right Departments Dropdown
  selectDepartmentRightColumn(department) {
    this.selectedDepartmentRightColumn.id = department.id;
    this.selectedDepartmentRightColumn.name = department.name;
    this.selectedPositionRightColumn.id = '';
    this.selectedPositionRightColumn.name = 'Select Position';
    this.searchPositionsRightColumn();
  }

  selectPositionRightColumn(position) {
    this.selectedPositionRightColumn.id = position.id;
    this.selectedPositionRightColumn.name = position.name;
    if (this.selectedDepartmentRightColumn.id.length < 1) {
      this.searchGroupRight();
    }
  }

  searchGroupRight() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedPositionRightColumn.id.length > 0) {
      params.positionId = this.selectedPositionRightColumn.id;
    }

    this.stdManagementService.searchManagementGroup(params.searchField, params.searchOperation, params.searchValue, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.departmentsRightColumn = response.body;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchPositionsRightColumn() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      groupId: '',
      userId: ''
    };

    if (this.selectedDepartmentRightColumn.id.length > 0) {
      params.groupId = this.selectedDepartmentRightColumn.id;
    }

    this.stdManagementService.searchManagementPositions(params.searchField, params.searchOperation, params.searchValue, params.groupId, params.userId).subscribe(
      (response: any) => {
        this.positionsRightColumn = response.body;
        this.positionsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  clearAllRightColumn() {
    this.selectedDepartmentRightColumn.id = '';
    this.selectedDepartmentRightColumn.name = 'Select Department';
    this.selectedPositionRightColumn.id = '';
    this.selectedPositionRightColumn.name = 'Select Position';
    this.nameInput = '';
    this.numberInput = '';
    this.selectedStandardsRightColumn = [];
    this.searchGroupRight();
    this.searchPositionsRightColumn();
    this.searchStandardsWithName();
  }

  /*
 MISC

   Sorting array by values A-Z
*/
  sortList(prop, list) {
    if (list !== undefined) {
      return list.sort((a, b) => a[prop].toLowerCase() > b[prop].toLowerCase() ? 1 : a[prop].toLowerCase() === b[prop].toLowerCase() ? 0 : -1);
    }
  }

  loaded() {
    return this.usersLoaded && this.positionsLoaded && this.departments && !this.errorLoading;
  }

  disabledUnassignButton() {
    if ((this.selectedStandardsLeftColumn.length < 1 && this.selectedPersonalStandardsLeftColumn.length < 1) ||
      this.selectedStandardsLeftColumn.length > 0 && this.selectedDepartment.id.length < 1 && this.selectedUser.id.length < 1) {
      return true;
    }
  }

  disabledAssignButton() {
    if ((this.selectedDepartment.id.length < 1 && this.selectedPosition.id.length < 1 && this.selectedUser.id.length < 1) ||
      this.selectedStandardsRightColumn.length < 1 && this.selectedInactiveByPositionStandards.length < 1) {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standards-management/standards-management.component.ts